import script from "./custom-number-input.vue?vue&type=script&lang=ts&setup=true"
export * from "./custom-number-input.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__